import { TMachineMaintenanceEnvironmentVars } from '@monorepo/types';

export const environment: TMachineMaintenanceEnvironmentVars = {
  production: false,
  mode: 'kalpha',
  appType: 'MM_APP_SOLVEI8',
  protocol: 'https://',
  service_host: 'kalpha-n-machine-maintenance-web-external.strawmine.com',
  reports_host: 'analytics.kalpha.strawmine.com',
  machine_maintainance: '/machine-maintenance/ext',
  auth_services: '/auth_services/ext',
  unified_login: 'auth.strawmine.com',
  data_gateway: '/data_gateway/ext',
};
